import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.renamePOPDFLabelSet.presenters.renamePOPDFLabelSetFormPresenter`

export default defineMessages({
  saveButton: {
    id: `${scope}.saveButton`,
    defaultMessage: 'Save',
  },
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'The PDF label has been renamed to {name}',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to rename the label set.',
  },
})
